import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getLeagueOptions, getLeagueValue } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import MultiSelectDropdown from '../MultiSelectComponent/MultiSelectPrimary/selectDropDownComponent';
import { SingleOption } from '../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';
import { setLeagueValue } from '../../../redux/reducers/licenceAnalytics';

const LeagueFilterComponent: React.FC = () => {
  const dispatch = useDispatch();
  const leagueOptions: SingleOption[] = useSelector(getLeagueOptions);
  const leagueValue: SingleOption | SingleOption[] | undefined = useSelector(getLeagueValue);
  const [t] = useTranslation();

  const onChange = (newValue: SingleOption | SingleOption[] | undefined): void => {
    dispatch(setLeagueValue({ newValue }));
  };

  return (
    <MultiSelectDropdown
      title={t('LEAGUE')}
      options={leagueOptions}
      value={leagueValue}
      getId={(obj: SingleOption | any): string => obj.id}
      getLabel={(obj: SingleOption): string => obj.name}
      onChange={onChange}
      isMulti={true}
      width="100%"
      rootCss={{ width: '100%' }}
    />
  );
};

export default LeagueFilterComponent;
